import { Heart } from 'lucide-react'

export default function Footer() {
  return (
    <div className="w-full mt-auto relative overflow-hidden">
      <div className="absolute inset-0 opacity-20 pointer-events-none">
        <div className="absolute inset-0 [background:linear-gradient(45deg,#0a0a0a,theme(colors.background)_50%,#0a0a0a)_padding-box,conic-gradient(from_var(--border-angle),theme(colors.contentBorder)_80%,_theme(colors.turquoise.DEFAULT)_86%,_theme(colors.turquoise.light)_90%,_theme(colors.turquoise.DEFAULT)_94%,_theme(colors.contentBorder))_border-box] border-t border-transparent animate-border"></div>
      </div>
      
      <footer className="flex items-center h-20 justify-center relative z-10 bg-background/50 backdrop-blur-sm">
        <span className="text-gray-300">made with</span>
        <Heart className="mx-2 h-4 w-4 text-turquoise fill-turquoise animate-pulse" />
        <span className="text-gray-300">using</span>
        <span className="ml-2 font-semibold text-turquoise">React</span>
      </footer>
    </div>
  )
}
